import React from 'react';
import { IconCheckmark } from '@noths/polaris-client-ribbons-design-system';
import type { CurrencyCode } from '@noths/polaris-dev-ts-types';

import { Price } from '../Price/Price';
import * as styles from './Check.styles';

export interface CheckProps {
  currency?: CurrencyCode;
  isSelected: boolean;
  label: string;
  onClick?: VoidFunction;
  onFocus?: VoidFunction;
  price?: number;
}

export const Check = ({ currency, isSelected, label, onClick, onFocus, price }: CheckProps) => (
  <button
    aria-pressed={isSelected}
    css={styles.button}
    onClick={onClick}
    onFocus={onFocus}
    type="button"
  >
    <div css={styles.checkWrapper}>
      <IconCheckmark
        color={`var(--brand-purple-base)`}
        css={styles.checkmark}
        dataAttributes={{ 'is-selected': String(isSelected) }}
      />
      <span
        css={styles.label}
        dangerouslySetInnerHTML={{ __html: label }}
        data-is-selected={isSelected}
      />
    </div>
    <Price currency={currency} price={price} />
  </button>
);
